
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sveitarfelog",
      function () {
        return require("private-next-pages/sveitarfelog/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sveitarfelog"])
      });
    }
  